import "core-js/modules/es.array.concat.js";
import { postReq, putReq, getReq, deleteReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/borrower-expense");
export var getBorrowerExpense = function getBorrowerExpense(idNumber, body) {
  return getReq("".concat(BASE_URL, "/").concat(idNumber), body);
};
export var addBorrowerExpense = function addBorrowerExpense(idNumber, body) {
  return postReq("".concat(BASE_URL, "/").concat(idNumber), body);
};
export var editBorrowerExpense = function editBorrowerExpense(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};
export var deleteBorrowerExpense = function deleteBorrowerExpense(id) {
  return deleteReq("".concat(BASE_URL, "/").concat(id));
};